/** Datas civis no fuso de Brasília — evita off-by-one de `toISOString().slice(0, 10)` após 21h BRT. */

const BR_TZ = 'America/Sao_Paulo';

export function todayYmdBr(now: Date = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: BR_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(now);
}

export function ymdFromDateBr(d: Date): string {
  return new Intl.DateTimeFormat('en-CA', {
    timeZone: BR_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).format(d);
}

export function addDaysYmdBr(ymd: string, days: number): string {
  const [year, month, day] = ymd.slice(0, 10).split('-').map(Number);
  const d = new Date(Date.UTC(year, month - 1, day + days, 12, 0, 0));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
}

export function firstDayOfMonthYmdBr(offsetMonths = 0): string {
  const today = todayYmdBr();
  const [year, month] = today.split('-').map(Number);
  const d = new Date(Date.UTC(year, month - 1 + offsetMonths, 1, 12, 0, 0));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-01`;
}

export function lastDayOfMonthYmdBr(offsetMonths = 0): string {
  const today = todayYmdBr();
  const [year, month] = today.split('-').map(Number);
  const d = new Date(Date.UTC(year, month + offsetMonths, 0, 12, 0, 0));
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}-${String(d.getUTCDate()).padStart(2, '0')}`;
}

export function daysAgoYmdBr(days: number): string {
  return addDaysYmdBr(todayYmdBr(), -days);
}

/** Limites do mês civil corrente em SP (YYYY-MM-DD), até hoje (não inclui dias futuros). */
export function currentMonthBoundsYmdBr(): { from: string; to: string } {
  return { from: firstDayOfMonthYmdBr(), to: todayYmdBr() };
}

/** Dia civil em Brasília para timestamptz (evita usar só a parte UTC da ISO após 21h BRT). */
export function ymdFromInstantBr(iso: string): string {
  const ms = Date.parse(String(iso));
  if (Number.isNaN(ms)) return String(iso).slice(0, 10);
  const d = new Date(ms - 3 * 60 * 60 * 1000);
  const y = d.getUTCFullYear();
  const m = String(d.getUTCMonth() + 1).padStart(2, '0');
  const day = String(d.getUTCDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Data+hora civil em Brasília (timestamptz ISO ou similar). */
export function formatDateTimeBr(iso?: string | null): string {
  if (!iso) return '—';
  try {
    return new Date(String(iso).trim()).toLocaleString('pt-BR', {
      timeZone: BR_TZ,
      dateStyle: 'short',
      timeStyle: 'short',
    });
  } catch {
    return String(iso);
  }
}

/** YYYY-MM-DD → dd/mm (dia civil, sem conversão de fuso). */
export function formatYmdShortBr(ymd: string): string {
  const m = String(ymd).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return ymd;
  return `${m[3]}/${m[2]}`;
}
